import React from 'react'
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card"

export default function ThankYou() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-white">
      <Card className="max-w-3xl w-full rounded-lg border-0 bg-transparent shadow-none">
        <CardContent className="p-0">
          <div className="text-center px-6 py-12">
            <CardTitle className="text-4xl font-medium tracking-tight lowercase">thank you</CardTitle>

            <p className="mt-6 text-base text-slate-700 leading-7">
              Accelera è stato disattivato il giorno 29 maggio 2026.
              <br />
              Sviluppare un software da zero è stato il mio sogno per tanti anni, e Accelera è stato il primo di molti progetti. Grazie a tutti coloro che lo hanno utilizzato e che hanno contribuito con feedback preziosi.
            </p>

            <p className="mt-6 text-sm text-slate-500">— Matias Galliani</p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
